import { gql } from '@apollo/client'

export const GET_TEAM_ADMINS_BY_PROFILE_ID = gql`
  query GetTeamAdminsByProfileId($profileId: ID!) {
    getTeamAdminsByProfileId(profileId: $profileId) {
      rows {
        id
        profileId
        teamId
        role
        profile {
          id
          firstName
          lastName
          phoneMobile
          photo
          globalAdmin
          emailAddresses {
            emailAddress
            primary
          }
          createdAt
        }
        team {
          id
          name
          teamLogoURL
          tags
          slug
          customPushNotificationAccess
          maxActiveTemplates
          teamParentId
        }
      }
    }
  }
`

export const GET_PROFILE_BY_ID = gql`
  query GetProfileById($id: ID) {
    profile(id: $id) {
      id
      firstName
      lastName
      phoneMobile
      photo
      globalAdmin
      emailAddresses {
        emailAddress
        primary
      }
      createdAt
    }
  }
`
